document.addEventListener('DOMContentLoaded', function () {
  const meta = document.getElementById('size-guide-meta');
  if (!meta) return;

  let pages;
  try {
    pages = JSON.parse(meta.textContent);
  } catch (e) {
    return;
  }

  if (!pages || pages.length === 0) return;

  const url = pages[0].url;
  const title = pages[0].title;
  if (!url) return;

  const summaries = document.querySelectorAll('.details__header');
  summaries.forEach(function (summary) {
    const text = summary.textContent.toLowerCase();
    if (text.includes('talla') || text.includes('tallaje')) {
      const content = summary.closest('details')?.querySelector('.details-content');
      if (!content) return;
      const link = document.createElement('div');
      link.style.cssText = 'padding: 0.5rem 0; font-size: 0.875em; text-decoration: underline;';
      link.innerHTML = '<a href="' + url + '">' + title + '</a>';
      content.appendChild(link);
    }
  });
});

